export enum AuthorizationResult {
  authorized = 1,
  forbidden = 2,
  unauthorized = 3
}
